import type { UserActivationApi } from '@hibro/shared';
import type { ReactNode } from 'react';

import {
  unavailableUserActivation,
  UserActivationContext,
} from './user-activation-context';

export function UserActivationProvider({
  api,
  children,
}: {
  api?: UserActivationApi;
  children: ReactNode;
}): ReactNode {
  return (
    <UserActivationContext.Provider value={api ?? unavailableUserActivation}>
      {children}
    </UserActivationContext.Provider>
  );
}
